<template>
    <div class="user-list d-flex" v-for="user in users" :key="user.account_id">
        <router-link to="/user-profile" class="user-image" v-if="user.profile_image">
            <img :src="user.profile_image" :alt="user.display_name">
        </router-link>
        <div class="user-content">
            <h3 class="user-name" v-if="user.display_name">{{user.display_name}}</h3>
            <span class="user-location">{{user.location}} - <span class="reputation-score">473</span></span>
            <div class="user-tags d-flex flex-wrap" v-if="user.tags">
                <router-link :to="tag.url" v-for="(tag, index) in user.tags" :key="index">
                    {{tag.title}}
                </router-link>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'User',
    props: ['users'],
    data() {
        return {
            
        }
    }
}
</script>